import React from 'react';
import { PHONE_PATH } from '../../../components/shared-components/listing-icons';
import { ICON_PATHS } from '../../../components/shared-components/icon-paths';

// line icons on a 24px grid, keyed like the listing flags and amenities
const ICONS = {
    salon: <><path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3" /><path d="M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z" /><path d="M4 18v2M20 18v2" /></>,
    duplex: <><path d="M4 21V9l8-6 8 6v12Z" /><path d="M4 14h16" /><path d="M9 21v-3h3v-2h3" /></>,
    not_house: <><rect x="5" y="3" width="14" height="18" rx="1" /><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01" /><path d="M10 21v-3h4v3" /></>,
    not_last_floor: <><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /></>,
    attic: <><path d="M3 12 12 4l9 8" /><path d="M5 10v10h14V10" /><path d="M10 13h4v3h-4Z" /></>,
    energy_passport: <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />,
    exchange: <><path d="m17 2 4 4-4 4" /><path d="M3 11v-1a4 4 0 0 1 4-4h14" /><path d="m7 22-4-4 4-4" /><path d="M21 13v1a4 4 0 0 1-4 4H3" /></>,
    terrace: <><circle cx="18" cy="5.5" r="2" /><path d="m3 8 5.5 7H21" /><path d="m6.5 15-2 5M19 15l1.5 5M10 15l-1 5" /></>,
    balcony: <><path d="M8 10V4h8v6" /><path d="M3 10h18M3 20h18" /><path d="M5 10v10M9 10v10M15 10v10M19 10v10" /></>,
    lift: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="m9 10 3-3 3 3" /><path d="m9 14 3 3 3-3" /></>,
    basement: <><path d="M3 9 12 3l9 6" /><path d="M5 8v13h14V8" /><path d="M12 10v7" /><path d="m9 14 3 3 3-3" /></>,
    hot_water: <><path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z" /><path d="M9.5 15a2.5 2.5 0 0 0 2.5 2.5" /></>,
    has_phone: PHONE_PATH,
    internet: <><path d="M2 9a15 15 0 0 1 20 0" /><path d="M5 12.5a10 10 0 0 1 14 0" /><path d="M8.5 16a5 5 0 0 1 7 0" /><path d="M12 19.5h.01" /></>,
    cable: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="m8 3 4 4 4-4" /></>,
    ac: <><path d="M12 2v20M3.3 7l17.4 10M3.3 17 20.7 7" /><path d="m9 3.5 3 2 3-2M9 20.5l3-2 3 2" /></>,
    interphone: <><rect x="6" y="2" width="12" height="20" rx="2" /><path d="M10 6h4M10 9h4" /><circle cx="12" cy="15" r="2" /></>,
    surveillance: <><path d="m16 13 5 3V8l-5 3" /><rect x="2" y="6" width="14" height="12" rx="2" /></>,
    garage: <path d={ICON_PATHS.garage} />,
    parking: <><rect x="3" y="3" width="18" height="18" rx="3" /><path d="M9 17V7h4a3 3 0 0 1 0 6H9" /></>,
};

// anything without an icon of its own gets a tick
const FALLBACK = <path d="m5 12.5 4.5 4.5L19 7.5" />;

export const AmenityIcon = ({ name }) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden='true'>
        {ICONS[name] || FALLBACK}
    </svg>
);
